export class ErrorEnum {
    //包签打印
    public static BD001: string = "打印失败";
    public static BD002: string = "打印失败:接口返回值为空。解决方法:请检查接口返回值";
}
